/**
 * SectionList.js
 */

import React, {useMemo} from 'react';
import styled from 'styled-components';
import Section from './SectionItem';
import {labels} from '../../../../util/utils';
import {loadStorage} from '../../localStorage';
import {clientSideEventNames, validationFilter} from '../../../../util/uiconstants';

export default function SectionList(props) {
	const {
		bodyOnlyView,
		formData,
		sections,
		header,
		hasHeaders,
		setSelectedSection,
		selectedSection,
		forceReload,
		isSnapshotView,
		changesView,
		commentsCleared,
		nextName,
		previousName,
		onNext,
		onPrevious,
		isFiltered,
		isDeleteHeader
	} = props;

	const getDisplayedSections = () => {
		return header?.sections?.filter((s) => s.isDisplayed === true || s.isCustom === true) || [];
	};

	const savedValidationFilter = loadStorage('validationsFilter');
	if (
		sections &&
		sections.allIds &&
		sections.allIds.length === 0 &&
		hasHeaders &&
		savedValidationFilter === validationFilter.INCOMPLETE
	) {
		setTimeout(() => {
			window.dispatchEvent(new CustomEvent(clientSideEventNames.unselectCurrentSectionId));
		}, 500);
	}

	const displayLabels = useMemo(() => {
		return (
			<>
				{isDeleteHeader ? (
					<section className="emptyContainer">{labels.selectHeaderFromRail}</section>
				) : (
					<>
						{savedValidationFilter === validationFilter.INCOMPLETE && hasHeaders ? (
							<section className="emptyContainer">{labels.noIncompleteBodies}</section>
						) : savedValidationFilter === validationFilter.NONE && !hasHeaders ? (
							<section className="emptyContainer">{labels.noContentAvailable}</section>
						) : savedValidationFilter === validationFilter.COMMENTS && hasHeaders ? (
							<section className="emptyContainer">{labels.noUnresolvedComments}</section>
						) : (
							<section className="emptyContainer">
								{!hasHeaders
									? labels.noContentAvailable
									: header?.id === 0
									? labels.noIncompleteBodies
									: labels.noSectionsAvailable}
							</section>
						)}
					</>
				)}
			</>
		);
	}, [isDeleteHeader, savedValidationFilter, hasHeaders]);

	return (
		<StyledSectionList
			className={`'StyledSectionList SelectedCanvasFormBody ' ${bodyOnlyView === true ? '' : 'customScrollbar'}`}
		>
			{bodyOnlyView && bodyOnlyView === true ? (
				(isFiltered === true && !selectedSection) || isDeleteHeader ? (
					<>{displayLabels}</>
				) : (
					<>
						{selectedSection ? (
							<Section
								bodyOnlyView={bodyOnlyView}
								isSnapshotView={isSnapshotView}
								commentsCleared={commentsCleared}
								forceReload={forceReload}
								formData={formData}
								setSelectedSection={setSelectedSection}
								selectedSectionId={selectedSection?.id}
								key={selectedSection?.id}
								section={selectedSection}
								headerId={header?.id}
								isExpanded
								changesView={changesView}
								onNext={onNext}
								onPrevious={onPrevious}
								nextName={nextName}
								previousName={previousName}
							/>
						) : (
							<>
								{header && getDisplayedSections().length === 0 && (
									<section className={`emptyContainer`}>{labels.noSectionsAvailable}</section>
								)}
							</>
						)}
					</>
				)
			) : (
				<>
					{sections && sections.length > 0 ? (
						sections.map((section) => {
							return (
								<Section
									bodyOnlyView={bodyOnlyView}
									isSnapshotView={isSnapshotView}
									commentsCleared={commentsCleared}
									forceReload={forceReload}
									formData={formData}
									setSelectedSection={setSelectedSection}
									selectedSectionId={selectedSection?.id}
									key={section.id}
									section={section}
									headerId={header?.id}
									isExpanded={section.id === selectedSection?.id}
									changesView={changesView}
								/>
							);
						})
					) : (
						<>{displayLabels}</>
					)}
				</>
			)}
		</StyledSectionList>
	);
}

const StyledSectionList = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 100%;
	padding: 0;
	overflow-y: auto;
	width: 100%;
	position: relative;
	&.customScrollbar {
		overflow-y: overlay;
		z-index: 9;
	}
	.bodyOnlyView {
		height: 95% !important;
	}
	.emptyContainer {
		&.bodyOnlyView {
			height: 95% !important;
			margin-bottom: var(--px-5);
			padding-top: var(--px-20);
		}
	}
`;
